// import { useEffect, useState } from "react";

// // @material-ui core components
// import Card from "@mui/material/Card";
// import Grid from "@mui/material/Grid";

// // Arakan components
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDButton from "components/MDButton";
// import MDAlert from "components/MDAlert";

// // Settings page components
// import FormField from "components/FormField";

// import { IconButton, InputLabel } from "@mui/material";

// // Import from Material-UI icons
// import AttachFileIcon from "@mui/icons-material/AttachFile";
// // or
// import MDInput from "components/MDInput";
// import LangSwitcher from "components/LangSwitcher";
// import MDEditor from "components/MDEditor";

// function LangForm({
//   article,
//   id,
//   info,
//   setInfo,
//   changeHandler,
//   notification,
//   setNotification,
//   errors,
//   type,
//   prefix,
//   isFieldVisible,
//   setErrors,
// }) {
//   const [selectedLang, setSelectedLang] = useState();
//   const [oldSelectedLang, setOldSelectedLang] = useState();

//   // get data from infoHis when change language selection from lang switcher

//   useEffect(() => {
//     // If there's no translations, it's empty, or no language is selected, bail out
//     setInfo(null);

//     if (
//       !article?.translations ||
//       Object.keys(article?.translations).length === 0 ||
//       !selectedLang
//     )
//       return;
//     let newData = {};
//     if (oldSelectedLang?.code && oldSelectedLang.code !== selectedLang.code) {
//       newData = { ...(info?.translations || {}) };
//       newData[oldSelectedLang.code] = {
//         ...(info?.translations?.[oldSelectedLang.code] || {}),
//         languages_code: oldSelectedLang.code,
//       };
//     }
//     if (oldSelectedLang?.code === selectedLang.code)
//       setInfo({
//         translations: article?.translations,
//       });
//     else
//       setInfo({
//         translations: newData,
//       });
//   }, [article, selectedLang]);

//   useEffect(() => {
//     if (!selectedLang?.code) return;

//     setInfo((prev) => {
//       // Clone translations
//       const translations = { ...(prev?.translations || {}) };

//       // If this language doesn’t exist, initialize it
//       if (!translations[selectedLang.code]) {
//         translations[selectedLang.code] = {
//           title: "",
//           link: "",
//           link_text: "",
//           description: "",
//           languages_code: selectedLang.code,
//         };
//       }

//       return { ...prev, translations };
//     });
//   }, [selectedLang]);

//   // useEffect(() => {
//   //   if (notification.value === true) {
//   //     setTimeout(() => {
//   //       setNotification({ value: false, color: "info", message: "" });
//   //     }, 5000);
//   //   }
//   // }, [notification]);

//   const safeHistory = info?.translations?.[selectedLang?.code] || {};
//   //
//   // isFieldVisible(prefix + "translations_ar-SA_description", type)
//   return (
//     <>
//       <Card sx={{ overflow: "visible", p: 5 }}>
//         <MDBox p={3}>
//           <Grid container spacing={3}>
//             <Grid item xs={12} lg={12}>
//               <LangSwitcher
//                 setSelectedLang={setSelectedLang}
//                 setOldSelectedLang={setOldSelectedLang}
//                 stickyNavbar={false}
//               />
//             </Grid>
//             {isFieldVisible(prefix + "translations_ar-SA_title", type) && (
//               <Grid item xs={12} lg={12}>
//                 <FormField
//                   onChange={(e) => changeHandler(e, selectedLang.code)}
//                   label={
//                     type !== "data_with_table_content" ? "الاسم" : "العملة"
//                   }
//                   name="title"
//                   value={safeHistory?.title ?? ""}
//                   error={errors.title}
//                 />
//               </Grid>
//             )}
//             {/* )} */}
//             {/* {info.translations[selectedLang?.code] && ( */}
//             {isFieldVisible(prefix + "translations_ar-SA_link", type) && (
//               <Grid item xs={12} lg={12}>
//                 <FormField
//                   onChange={(e) => changeHandler(e, selectedLang.code)}
//                   label={
//                     type === "leadership"
//                       ? "المسمي الوظيفي"
//                       : type === "data_with_table_content"
//                       ? "الإيبان"
//                       : "الرابط"
//                   }
//                   name="link"
//                   value={safeHistory?.link ?? ""}
//                   error={errors.link}
//                 />
//               </Grid>
//             )}
//             {isFieldVisible(prefix + "translations_ar-SA_link_text", type) && (
//               <Grid item xs={12} lg={12}>
//                 <FormField
//                   onChange={(e) => changeHandler(e, selectedLang.code)}
//                   label={"نص الرابط"}
//                   name="link_text"
//                   value={safeHistory?.link_text ?? ""}
//                   error={errors.link_text}
//                 />
//               </Grid>
//             )}
//             {isFieldVisible(
//               prefix + "translations_ar-SA_description",
//               type,
//             ) && (
//               <Grid item xs={12} lg={12}>
//                 <MDEditor
//                   onChange={(e) => changeHandler(e, selectedLang.code)}
//                   label="التفاصيل"
//                   name="description"
//                   value={safeHistory?.description ?? ""}
//                   error={errors.description}
//                   placeholder="اكتب التفاصيل هنا..."
//                   success={
//                     true
//                     // safeHistory?.description?.length > 0 && !errors.description
//                   }
//                 />
//               </Grid>
//             )}
//           </Grid>
//         </MDBox>
//       </Card>
//       {/* {notification.value === true && (
//         <MDAlert color={notification.color} mt="20px">
//           <MDTypography variant="body2" color="white">
//             {notification.message}
//           </MDTypography>
//         </MDAlert>
//       )} */}
//     </>
//   );
// }

// export default LangForm;
import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Arakan components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "components/FormField";

import { IconButton, InputLabel } from "@mui/material";

// Import from Material-UI icons
import AttachFileIcon from "@mui/icons-material/AttachFile";
// or
import MDInput from "components/MDInput";
import LangSwitcher from "components/LangSwitcher";
import MDEditor from "components/MDEditor";
import { tr } from "date-fns/locale";
import ArticleImage from "../ArticleImage";
import ProductImage from "cruds/projects/add-project/components/ProductImage";
import { G } from "@react-pdf/renderer";

function LangForm({
  article,
  id,
  info,
  setInfo,
  changeHandler,
  notification,
  setNotification,
  errors,
  type,
  prefix,
  isFieldVisible,
  setErrors,
}) {
  const [selectedLang, setSelectedLang] = useState();
  const [oldSelectedLang, setOldSelectedLang] = useState();
  const baseUrl = process.env.REACT_APP_API_URL;

  // Initialize default translations structure
  const defaultTranslations = {
    ar_SA: {
      title: "",
      link: "",
      link_text: "",
      description: "",
      languages_code: "ar_SA",
    },
    en_US: {
      title: "",
      link: "",
      link_text: "",
      description: "",
      languages_code: "en_US",
    },
    tr_TR: {
      title: "",
      link: "",
      link_text: "",
      description: "",
      languages_code: "tr_TR",
    },
  };

  // Handle language switching
  useEffect(() => {
    // Don't proceed if no language is selected
    if (!selectedLang?.code) return;

    // If article has translations and we're switching languages
    if (
      article?.translations &&
      Object.keys(article?.translations).length > 0
    ) {
      setInfo((prevInfo) => {
        // Safely get current translations
        const currentTranslations = prevInfo?.translations || {};

        // Create new translations object
        let newTranslations = { ...currentTranslations };

        // If we have an old language and it's different from the new one
        if (
          oldSelectedLang?.code &&
          oldSelectedLang.code !== selectedLang.code
        ) {
          // Save the old language's data before switching
          if (currentTranslations[oldSelectedLang.code]) {
            newTranslations[oldSelectedLang.code] = {
              ...currentTranslations[oldSelectedLang.code],
              languages_code: oldSelectedLang.code,
            };
          }
        }

        // If switching to a language that doesn't exist in current translations
        if (!newTranslations[selectedLang.code]) {
          // Try to get from article translations first
          if (article?.translations?.[selectedLang.code]) {
            newTranslations[selectedLang.code] = {
              ...article.translations[selectedLang.code],
              languages_code: selectedLang.code,
            };
          } else {
            // Otherwise initialize with empty values
            newTranslations[selectedLang.code] = {
              title: "",
              link: "",
              link_text: "",
              description: "",
              languages_code: selectedLang.code,
            };
          }
        }

        return { ...prevInfo, translations: newTranslations };
      });
    }
  }, [selectedLang, oldSelectedLang, article]);

  // Initialize translations for new language if it doesn't exist
  useEffect(() => {
    if (!selectedLang?.code) return;

    setInfo((prev) => {
      // If prev is null or undefined, initialize it
      if (!prev) {
        return {
          translations: {
            [selectedLang.code]: {
              title: "",
              link: "",
              link_text: "",
              description: "",
              languages_code: selectedLang.code,
            },
          },
        };
      }

      // Clone translations safely
      const translations = { ...(prev?.translations || {}) };

      // If this language doesn't exist, initialize it
      if (!translations[selectedLang.code]) {
        translations[selectedLang.code] = {
          title: "",
          link: "",
          link_text: "",
          description: "",
          languages_code: selectedLang.code,
        };
      }

      return { ...prev, translations };
    });
  }, [selectedLang]);

  // Reset info when article changes
  useEffect(() => {
    if (article?.translations) {
      setInfo({
        translations: article.translations,
      });
    }
  }, [article, setInfo]);

  // Safely get current language data
  const getCurrentLangData = () => {
    if (!selectedLang?.code) return {};
    return info?.translations?.[selectedLang?.code] || {};
  };

  const safeHistory = getCurrentLangData();

  return (
    <>
      <Card sx={{ overflow: "visible", p: 5 }}>
        <MDBox p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <LangSwitcher
                setSelectedLang={setSelectedLang}
                setOldSelectedLang={setOldSelectedLang}
                stickyNavbar={false}
              />
            </Grid>

            {/* Only render fields if a language is selected */}
            {selectedLang?.code && (
              <>
                {isFieldVisible(prefix + "translations_ar-SA_logo", type) && (
                  <Grid item xs={12} lg={4}>
                    <MDTypography variant="h6" gutterBottom>
                      شعار الجمعية
                    </MDTypography>
                    <ProductImage
                      projectImage={
                        safeHistory?.pic
                          ? `${baseUrl}assets/${safeHistory?.pic}`
                          : null
                      }
                      value={safeHistory?.pic ?? null}
                      changeHandler={(e) =>
                        changeHandler(e, selectedLang?.code)
                      }
                      imgInfo={{ name: "صورة الموقع", dimentions: "" }}
                      error={errors[`pic-${selectedLang?.code}`]}
                      name="pic"
                    />
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  lg={
                    isFieldVisible(prefix + "translations_ar-SA_logo", type)
                      ? 8
                      : 12
                  }
                >
                  <Grid container spacing={3}>
                    {isFieldVisible(
                      prefix + "translations_ar-SA_title",
                      type,
                    ) && (
                      <Grid item xs={12} lg={12}>
                        <FormField
                          onChange={(e) => changeHandler(e, selectedLang.code)}
                          label={
                            type !== "data_with_table_content"
                              ? "الاسم"
                              : "العملة"
                          }
                          name="title"
                          value={safeHistory?.title ?? ""}
                          error={errors?.title}
                        />
                      </Grid>
                    )}

                    {isFieldVisible(
                      prefix + "translations_ar-SA_link",
                      type,
                    ) && (
                      <Grid item xs={12} lg={12}>
                        <FormField
                          onChange={(e) => changeHandler(e, selectedLang.code)}
                          label={
                            type === "leadership"
                              ? "المسمي الوظيفي"
                              : type === "data_with_table_content"
                              ? "الإيبان"
                              : "الرابط"
                          }
                          name="link"
                          value={safeHistory?.link ?? ""}
                          error={errors?.link}
                        />
                      </Grid>
                    )}

                    {isFieldVisible(
                      prefix + "translations_ar-SA_link_text",
                      type,
                    ) && (
                      <Grid item xs={12} lg={12}>
                        <FormField
                          onChange={(e) => changeHandler(e, selectedLang.code)}
                          label="نص الرابط"
                          name="link_text"
                          value={safeHistory?.link_text ?? ""}
                          error={errors?.link_text}
                        />
                      </Grid>
                    )}
                    {isFieldVisible(
                      prefix + "translations_ar-SA_description",
                      type,
                    ) && (
                      <Grid item xs={12} lg={12}>
                        <MDEditor
                          onChange={(e) => changeHandler(e, selectedLang.code)}
                          label="التفاصيل"
                          name="description"
                          value={safeHistory?.description ?? ""}
                          error={errors?.description}
                          placeholder="اكتب التفاصيل هنا..."
                          success={
                            safeHistory?.description?.length > 0 &&
                            !errors?.description
                          }
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </MDBox>
      </Card>
    </>
  );
}

export default LangForm;
